import { useState } from "react";
import axios, { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Youtube } from "lucide-react";

const AuthPage = ({ onAuth }) => {
  const [loading, setLoading] = useState(false);

  const handleGoogleAuth = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/auth/url`);
      window.location.href = response.data.auth_url;
    } catch (error) {
      console.error('Auth failed:', error);
      toast.error('Failed to initiate Google authentication');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Youtube className="w-8 h-8 text-red-600" />
          </div>
          <div>
            <CardTitle className="text-2xl font-bold text-gray-900">YouTube Live Scheduler</CardTitle>
            <p className="text-gray-600 mt-2">Schedule your videos as live streams with automated timing</p>
          </div>
        </CardHeader>
        <CardContent>
          <Button
            onClick={handleGoogleAuth}
            disabled={loading}
            className="w-full bg-red-600 hover:bg-red-700 text-white py-3"
            data-testid="google-auth-button"
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Connecting...
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <Youtube className="w-5 h-5" />
                Connect YouTube Channel
              </div>
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthPage;
